import {z} from 'zod'

import {FormValidationInput} from '../../types'
import {ErrorCodes} from '../common/validation/errorCodes'

import {ConcreteUsageConfiguration, ConcreteUsageForm} from './types'
const maxCharacters = 72

export const validateConcreteUsage = (
  data: ConcreteUsageForm,
  ctx: z.RefinementCtx,
  {
    configuration: {concreteUsage: usageConfiguration}
  }: FormValidationInput<ConcreteUsageConfiguration>
) => {
  // If usage field is not enabled, skip validation
  if (!usageConfiguration.isEnabled) {
    return
  }

  if (
    data.concreteUsage === undefined ||
    data.concreteUsage === null ||
    data.concreteUsage.trim() === ''
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['concreteUsage'],
      message: ErrorCodes.concreteUsage.required
    })
    return
  }

  if (data.concreteUsage.length > maxCharacters) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['concreteUsage'],
      message: ErrorCodes.concreteUsage.outOfRange
    })
  }
}
